import { GUTTER_SIZE, ROW_COL_SPAN } from '@modules/dashboard/constants';
import { alpha, Box, BoxProps } from '@mui/material';

interface DashboardCellResizePreviewProps {
  colWidth: number;
  firstVisiblePreviewIndicator: number;
  lastVisiblePreviewIndicator: number;
  sx: BoxProps['sx'];
}

export function DashboardCellResizePreview({
  colWidth,
  firstVisiblePreviewIndicator,
  lastVisiblePreviewIndicator,
  sx,
}: DashboardCellResizePreviewProps) {
  return (
    <Box
      className="cell-resize-preview"
      sx={{
        ...sx,
        display: 'flex',
      }}
    >
      {Array(ROW_COL_SPAN - 1)
        .fill(1)
        .map((_, index) => {
          const indicatorID = index + 1;

          const canShowPreviewIndicator =
            indicatorID >= firstVisiblePreviewIndicator &&
            indicatorID <= lastVisiblePreviewIndicator;

          return (
            <Box
              key={indicatorID}
              sx={{
                width: GUTTER_SIZE,
                visibility: canShowPreviewIndicator ? `visible` : `hidden`,
                marginLeft: `${colWidth}px`,
              }}
            >
              <Box
                sx={{
                  backgroundColor: (theme) =>
                    alpha(theme.palette.text.primary, 0.2),
                  height: '6px',
                  width: '6px',
                  borderRadius: '50%',
                  margin: 'auto',
                }}
              />
            </Box>
          );
        })}
    </Box>
  );
}
